<!-- render inside in a container div with correct sizing and padding -->
<div class="progressBarText">
  <p>{{ progressLabel ? progressLabel : 'Completed' }}</p>
  <p>{{ progressValue }}%</p>
</div>
<div class="progress" style="height: 6px">
  <div
    class="progress-bar"
    role="progressbar"
    [class.empty-progress]="progressValue === 0"
    [class.partial-progress]="progressValue < 50"
    [class.almost-progress]="progressValue < 100"
    [class.done-progress]="progressValue === 100"
    [style.width.%]="progressValue"
    [attr.aria-valuenow]="progressValue"
    aria-valuemin="0"
    aria-valuemax="100"
  ></div>
</div>
